import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import etfDividendService from "@etfDividendService";

export function useFetchETFDividends(holdingId?: string) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['etf_dividends', user?.id, holdingId],
    queryFn: async () => {
      return await etfDividendService.fetchETFDividends({ holdingId, userId: user.id, });
    },
    enabled: !!user,
  });
}

export function useCreateETFDividend() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (dividend: Omit<ETFDividendCreateRequest, "userId">) => {
      return await etfDividendService.createETFDividend({...dividend, userId: user.id});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['etf_dividends'] }),
  });
}

export function useDeleteETFDividend() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (id: string) => {
      return await etfDividendService.deleteETFDividend({ id, userId: user.id});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['etf_dividends'] }),
  });
}
